export default __webpack_public_path__ + "static/media/review1.5700a298.png";